

import { useState } from 'react';

import PassForm from './PassForm';
import Prezentacja from './panel/Prezentacja';

function Layout(props)
{

    const [sell_videoId, setVideoId] = useState(null);

    


    var content = null;
    if(sell_videoId > 0 )
    {
        content = <Prezentacja id={sell_videoId} />

    }else
    {
        content =  <PassForm  setVideoId={setVideoId}/>
    }


    return (
        <div className='elizak_prezentacja'>
                <div className='header_x'>
                    eLizak.edu.pl &nbsp; 
                </div>

                <div className='content_x'>
                    {content}
                </div>

                <div className='foot_x'>
                    elizak.edu.pl © Wszystkie prawa zastrzeżone.
                </div>
        </div>
    )
}



export default Layout;